import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import './style.css'
import 'moment/locale/ru'
import 'moment/locale/be'
import moment, {Moment} from "moment";
import {actions} from "../store/actions";
import {Button, DatePicker, Form, Input, Modal, Select} from "antd";
import {AppStateType} from "../../../store";
import {api} from "../store/api";
import {maskMap, setFormErrors} from "../../../api/types";
import LocalLoading from "../../../components/Loading/Local";

interface Values {
    payType: string
    payDate: Date
    payNumber: string
}
type PropsType = {
    open: boolean
    setOpen: (open: boolean) => void
    isAuth: boolean
}

export default function CheckPay(props: PropsType) {
    const {open, setOpen, isAuth} = props;
    const {i18n} = useTranslation();
    const {t} = useTranslation(['resources', 'validation'])
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const {payType, payDate, payNumber, isAsked, isLoading} = useSelector((state: AppStateType) => state.payment)
    //const [initDate, setInitDate] = useState(new Date(payDate));
    const [message, setMessage] = useState('');
    const { Option } = Select

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (value: number) => {
        dispatch(actions.setPayType(value))
        //console.log(`Selected: ${value}`);
        switch (value) {
            case 10: {
                document.getElementById('payCalendar')!.style.display = 'block'
                break;
            }
            case 20: {
                document.getElementById('payCalendar')!.style.display = 'none'
                break;
            }
        }
    };

    const handleDateChange = (date: Moment | null) => {
        if(date?.isValid()) {
            let dti = date?.toISOString()
            dispatch(actions.setPayDate(dti))
        } else {
            if(payDate) {
                dispatch(actions.setPayDate(''))
            }
        }
        setMessage('')
    }

    const handleNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let payNum = event.target.value as string
        dispatch(actions.setPayNumber(payNum))
        setMessage('')
    }

    const onFinish = (values: any) => {
        dispatch(actions.setLoading(true))
        api.checkPay(values.payNumber, moment(values.payDate).format(), values.payType)
            .then(response => {
                if (response.code === 200) {
                    let {route, isMatch} = response.data;
                    dispatch(actions.setPayRoute(route, isMatch, response.message));
                    if (!isMatch) {
                        window.location.href = '/' + route + '?message=' + response.message + '&isArch=false'
                    }
                    setOpen(false);
                }
                else {
                    if(response.message) {
                        setMessage(response.message)
                    }
                }
            })
            .catch(err => {setFormErrors(err, form)})
            .finally(()=>{dispatch(actions.setLoading(false))})
    }

    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            md: { span: 11 },
            xxl: {span: 11 }
        },
        wrapperCol: {
            xs: { span: 24 },
            md: { span: 13 },
            xxl: {span: 13 }
        },
    };

    return (
        <Modal
            title={t('PaymentChecking')}
            visible={open}
            className='dialogSize'
            onCancel={handleClose}
            footer={[]}
        >
            {!isAuth || isAsked ? <Form
                form={form}
                name='checkPay'
                {...formItemLayout}
                onFinish={onFinish}
                //validateMessages={validateMessages}
                initialValues={{
                    payType: payType,
                    payDate: payDate ? moment(payDate) : undefined,
                    payNumber: payNumber
                }}
            >
                <Form.Item
                    label={t('PaymentMethodSelect')}
                    name="payType"
                >
                    <Select
                        onChange={handleChange}
                    >
                        <Option key='10' value={10}>{t('BankTransfer')}</Option>
                        <Option key='20' value={20}>{t('AIS')}</Option>
                    </Select>
                </Form.Item>
                <div id={'payCalendar'}>
                    <Form.Item
                        label={t('PaymentDate')}
                        name="payDate"
                        rules={[
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    let payType = getFieldValue('payType')
                                    if(payType === 10){
                                        if (!value) {
                                            return Promise.reject(new Error(t('validation:RequiredValue')))
                                        } else if (!moment(value).isValid()) {
                                            return Promise.reject(new Error(t('validation:DateFormatError')))
                                        }
                                    }
                                    return Promise.resolve()
                                }
                            })
                        ]}
                    >
                        <DatePicker
                            format={maskMap[i18n.language]}
                            disabledDate={d => !d || d.isAfter(moment(new Date()))}
                            onChange={(date: any) => handleDateChange(date)}
                        />
                    </Form.Item>
                </div>
                <Form.Item
                    label={payType === 20 ? t('SubscriptionNumber') : t('PaymentDocumentNumber')}
                    name="payNumber"
                    rules={[
                        {
                            required : true,
                            message : t('validation:RequiredField')
                        },
                        {
                            pattern: /^[0-9]{1,20}$/i,
                            message: t('validation:PayNumber'),
                        },
                    ]}
                >
                    <Input
                        onChange={handleNumberChange}
                    />
                </Form.Item>
                {/*<FormControlLabel
                    control={<Checkbox value="remember" color="primary"/>}
                    label={t('LoginViewModelRememberMe')}
                /> */}
                {message && <div className='errorMess'>{message}</div>}
                <Button
                    htmlType="submit"
                    color="primary"
                    loading={isLoading}
                    style={{display: 'block', marginLeft: 'auto'}}
                    //disabled={form.isSubmitting}
                >
                    {t('Confirm')}
                </Button>
            </Form> : <LocalLoading/>}
        </Modal>
    );
}
